import { render, staticRenderFns } from "./NowhowCheckbox.vue?vue&type=template&id=46909028"
import script from "./NowhowCheckbox.vue?vue&type=script&lang=ts"
export * from "./NowhowCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports